import React, { useEffect, useState } from "react";
import {  Button, TextArea, Picker} from "antd-mobile-v5";

import { DownOutline } from "antd-mobile-icons";
import type { RouteComponentProps } from "react-router-dom";
import { withRouter } from "react-router-dom";
import "./reportAgainTip.scss";
import { ApiCore } from "../../api";
import utils from "../../utils/utils";
import iconFile from "../../static/images/icon_file.png"
import { Toast } from "antd-mobile";
import backBtn from "../../static/icon/back_button.png";
const api = new ApiCore();

const ReportAgainTip = (props: RouteComponentProps<{ scaleCode: string; subjectCode: string }>) => {
  const urlParams = utils.getUrlParams();
  const { scaleCode, subjectCode } = props.match.params;
  const [rejectReason, setRejectReason] = useState<any>("");
  const [rejectState, setRejectState]  = useState<any>(9);
  const [reasonLabel, setReasonLabel] = useState<any>()
  const [bindInfo, setBindInfo] = useState<any>({})
  const [reasonList , setReasonList] = useState<any>( [[{ value:9, label:'其他原因' }]])

  const [pickerVisible, setPickerVisible] =  useState<boolean>(false)
  //悬浮按钮项相关
  let oLeft: any;
  let oTop: any;
  let moving: boolean = false;
  let oW: any;
  let oH: any;
  let htmlWidth: any;
  let htmlHeight: any;
  let bWidth: any;
  let bHeight: any;
  let click: boolean = false;
  useEffect(() => {
    let ele = document.getElementById("t-suspend-button");
    let recordStateLocal = localStorage.getItem("recordState");
    if (ele) {
      if (recordStateLocal) {
        let recordState = JSON.parse(recordStateLocal);
        ele.style.left = recordState.actionBall.left;
        ele.style.top = recordState.actionBall.top;
      }
      ele.addEventListener(
        "touchmove",
        (e) => {
          if (e.cancelable) {
            e.preventDefault();
          }
        },
        {
          passive: false,
        }
      );
    }
  }, []);
  
  useEffect(() => {
      document.title = "重新上报提醒"
      getInfo()
      setReasonLabel(reasonList[0].find((e:any)=>e.value == rejectState)?.label)
  }, []);

  // 计算结果
  useEffect(()=>{
    setReasonLabel(reasonList[0].find((e:any)=>e.value  == rejectState)?.label)
  }, [rejectState])

  //当开始触摸
  const onTouchStart = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    e = e.touches[0];
    click = true;
    if (ele) {
      ele.style.opacity = "1";
      oW = e.clientX - ele?.getBoundingClientRect().left;
      oH = e.clientY - ele?.getBoundingClientRect().top;
      htmlWidth = document.documentElement.clientWidth;
      htmlHeight = document.documentElement.clientHeight;
      bWidth = ele.offsetWidth;
      bHeight = ele.offsetHeight;
      oLeft = e.clientX - oW;
      oTop = e.clientY - oH;

      ele.style.left = oLeft + "px";
      ele.style.top = oTop + "px";
      moving = true;
    }
  };
   //当触摸结束
   const onTouchEnd = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    moving = false;

    // 左侧距离
    let oLeft1 = oLeft;
    if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
      oLeft1 = 0;
    } else {
      oLeft1 = `${htmlWidth - bWidth}px`;
    }
    oLeft = oLeft1;
    if (ele) {
      ele.style.left = oLeft;
      let recordState = {
        actionBall: {
          left: ele.style.left,
          top: ele.style.top,
        },
      };
      localStorage.setItem("recordState", JSON.stringify(recordState));
      setTimeout(() => {
        if (ele) {
          ele.style.opacity = "0.8";
        }
      }, 2000);
    }
  };

  // 当开始触摸
  const onTouchMove = (e: any) => {
    moving && onMove(e);
  };

  // 当触摸
  const onMove = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    e = e.touches[0];
    click = false;

    // 左侧距离
    let oLeft1 = e.clientX - oW;
    let oTop1 = e.clientY - oH;
    if (oLeft1 < 0) {
      oLeft1 = 0;
    } else if (oLeft1 > htmlWidth - bWidth) {
      oLeft1 = htmlWidth - bWidth;
    }
    if (oTop1 < 0) {
      oTop1 = 0;
    } else if (oTop1 > htmlHeight - bHeight) {
      oTop1 = htmlHeight - bHeight;
    }
    oLeft = oLeft1;
    oTop = oTop1;
    if (ele) {
      ele.style.left = oLeft + "px";
      ele.style.top = oTop + "px";
    }
  };

  // 获取绑定信息
  const getInfo = async ()=>{
    const { data } = await api.getSubjectBindState(subjectCode)
    setBindInfo(data)
  }
  // 重报提醒
  const sendRemind = ()=>{
    if (!rejectReason) return Toast.fail("请输入具体原因", 1)
    api.restatement({
      scaleId: urlParams?.scaleId,
      rejectState,
      rejectReason
    }).then((res:any)=>{
       const {code ,message} = res;
       if(code === 0){
          Toast.success("发送成功！",1)
          props.history.go(-1);
       }else{
          Toast.fail(message, 1)
       }
    })
  }

  
  return (
    <div className="main-container">
      <div className="card-container">
        <div className="card-title">上报提醒</div>
        <div className="card-content">
          <div className="card-content-part1"><img  src={iconFile} alt=""/>{urlParams?.scaleName}</div>
          {/* <div className="card-content-part2">应上报1次，实际上报<span style={{'color':'red'}}>0</span>次</div> */}
        </div>
        <div className="card-second-title">根据以下身份提醒患者上报</div>
        <div className="doctor-info">
          <div className="doctor-info-hospital">{bindInfo.centerName}</div>
          <div className="doctor-info-name">{bindInfo.doctorName}</div>
        </div>
      </div>
      <div className="card-container">
        <div className="card-title">选择上报原因</div>
        
        <div className="card-second-title" >选择原因</div>
        <div className="card-input" onClick={()=>{setPickerVisible(true)}}>
          <div>{reasonLabel}</div>
          <DownOutline />
        </div>
      
        <textarea
         className="card-textarea"
          placeholder='请输入具体原因'
          maxLength={200}
          onChange={e => {
            setRejectReason(e.target.value)
          }}
        />
        
      </div>
      <div className="btn-bottom">
        <Button  className="btn-bottom-content" color='primary'  shape='rounded' onClick={sendRemind} >发送提醒</Button>
        {/* <div className="btn-bottom-tip">每人每日仅能提醒一次</div> */}
      </div>
      <Picker
        columns={reasonList}
        visible={pickerVisible}

        onClose={() => {
          setPickerVisible(false)
        }}
        
        onConfirm={v => {
          setRejectState(v)
        }}
      />

     <div
        className="addAction"
        id="t-suspend-button"
        onTouchStart={(e) => onTouchStart(e)}
        onTouchMove={(e) => onTouchMove(e)}
        onTouchEnd={(e) => onTouchEnd(e)}
      >
        <img
          src={backBtn}
          alt="back"
          onClick={() => {
            props.history.go(-1);
          }}
        />
      </div>
    </div>
  );
};


export default withRouter(ReportAgainTip);
